import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
//import { environment } from '../../environments/environment';
import { environmentConfig } from 'src/environment';

@Component({
  selector: 'app-info',
  templateUrl: './app-info.component.html',
  styleUrls: ['./app-info.component.css']
})
export class AppInfoComponent implements OnInit {
  version = environmentConfig.version;
  releaseDate = environmentConfig.releaseDate;
  environment = environmentConfig.environment;
  userAdmin = sessionStorage.getItem('wOSAdmin');
  userInfo = sessionStorage.getItem('wOSUser');
  userEmail = '';
  userPic: any = '';
  userTimeZone: string | null = '';
  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    const uservar: string | null = sessionStorage.getItem("wOSUser");
    const test: any = (uservar != null) ? JSON.parse(uservar) : '';
    const timezone = sessionStorage.getItem('wOSTimezone');
    this.userTimeZone = (timezone == null) ? "America/New_York": timezone.toString();
    this.userEmail = test.email;
  }
  getTimeZone():any {
    const offset = new Date().getTimezoneOffset(), o = Math.abs(offset);
    return (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
  }
}
